import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AssignmentsXApiPayload } from 'src/interfaces/store.types';
import type { RootState } from 'src/store';
import { useAppSelector } from 'src/store/redux';

const initialState: AssignmentsXApiPayload = {
  assignmentsTotalCount: 0,
  displayedAssignmentsCount: 0,
  doneAssignmentsCount: 0,
};

export const assignmentsXApiPayloadSlice = createSlice({
  name: 'assignmentsXApiPayload',
  initialState,
  reducers: {
    setAssignmentsTotalCount: (state, action: PayloadAction<number>) => {
      state.assignmentsTotalCount = action.payload;
    },
    setDisplayedAssignmentsCount: (state, action: PayloadAction<number>) => {
      state.displayedAssignmentsCount = action.payload;
    },
    setDoneAssignmentsCount: (state, action: PayloadAction<number>) => {
      state.doneAssignmentsCount = action.payload;
    },
  },
});

export const {
  setAssignmentsTotalCount,
  setDisplayedAssignmentsCount,
  setDoneAssignmentsCount,
} = assignmentsXApiPayloadSlice.actions;

export const useAssignmentsXApiPayloadSelector = () =>
  useAppSelector((state: RootState) => state.assignmentsXApiPayload);

export default assignmentsXApiPayloadSlice.reducer;
